module.exports = "/_next/static/images/hci_under_ojk_right_white-2f7700a0812c69ab7a9bcd0e48b4029a.png";